import { render, staticRenderFns } from "./projectsDeposits.vue?vue&type=template&id=79ecc416&"
import script from "./projectsDeposits.vue?vue&type=script&lang=js&"
export * from "./projectsDeposits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports